// import Swiper from "swiper/bundle"; // For some reason importing swiper in this way causes the navigation not to work, amongst other issues. The bundle is enqueued the traditional WordPress way in enqueue-scripts.php. The CSS is in the swiper-bundle.scss partial.

import PhotoSwipeLightbox from "photoswipe/lightbox";

//-----------------------------------------------
// Collage Image with Carousel
//-----------------------------------------------

function collageImageWithCarousel(blockClass) {
	const blocks = document.querySelectorAll('.' + blockClass);
	if (!blocks) return;
	blocks.forEach(block => {
		const carousels = block.querySelectorAll('.' + blockClass + '__media');
		carousels.forEach(carousel => {
			const pagination = carousel.querySelector('.' + blockClass + '__media-carousel-pagination');

			const container = carousel.querySelector('.swiper-container');
			if (container) {
	    		const progress = carousel.querySelector('.' + blockClass + '__media-carousel-autoplay-progress');
	    		const progressCircle = progress.querySelector("svg");
	    		
				const swiper = new Swiper(container, {
					 autoplay: {
						delay: 6000,
					},
					loop: true,
					speed: 300,
					pagination: {
						el: pagination,
						clickable: true,
						disableOnInteraction: true,
					},
					on: {
						autoplayTimeLeft(s, time, progress) {
							progressCircle.style.setProperty("--progress", 1 - progress);
						},
					},
				});

				swiper.on('slideChangeTransitionEnd', e => {
					if (progress.classList.contains('paused')) {
						progress.click();
					}
				});

				progress.addEventListener('click', e => {
					if (swiper.autoplay.paused) {
						swiper.autoplay.resume();
						progress.classList.remove('paused');
					} else {
						swiper.autoplay.pause();
						progress.classList.add('paused');
					}
				})
			}
		})
	})
}

collageImageWithCarousel('collage-image-with-carousel');

function initCarouselLightbox() {
	const blocks = document.querySelectorAll('.collage-image-with-carousel');
	if (blocks.length < 1) return;

	blocks.forEach(block => {
		const galleries = block.querySelectorAll('.collage-image-with-carousel__media');
		galleries.forEach(gallery => {
			const lightbox = new PhotoSwipeLightbox({
				gallery: gallery,
				children: '.js-lightbox-item a',
				pswpModule: () => import("photoswipe"),

				// Disable default arrows so we can supply our own
				arrowPrev: false,
				arrowNext: false,
				zoom: false,
				counter: false,
				bgOpacity: 1,
				closeSVG: '<svg viewBox="0 0 17 18" aria-hidden="true" class="pswp__icn" width="17" height="18"><path d="m.55.51 15.452 16.692M16.002.51.551 17.202" stroke="#392422" stroke-width="1.5" stroke-miterlimit="10"/></svg>',

				padding: {
					top: 20,
					bottom: 20,
					left: 75,
					right: 75
				},

				paddingFn: (viewportSize, itemData, index) => {
					let padding;
					if (viewportSize.x < 753) {
						padding = {
							top: 56,
							bottom: 60,
							left: 20,
							right: 20,
						};
					} else if (viewportSize.x < 1264) {
						padding = {
							top: 60,
							bottom: 60,
							left: 30,
							right: 30,
						};
					} else {
						padding = {
							top: 100,
							bottom: 100,
							left: 100,
							right: 100,
						};
					}
					return padding;
				},
			});

			const swiper = gallery.querySelector('.swiper-container');
			if (swiper) {
				const swiperInstance = swiper.swiper;
				const swiperProgress = gallery.parentNode.querySelector(".collage-image-with-carousel__media-carousel-autoplay-progress");

				lightbox.on('change', () => {
					swiperInstance.slideTo(lightbox.pswp.currSlide.index, 0);

					if (!swiperInstance.autoplay.paused) {
						swiperInstance.autoplay.pause();
						swiperProgress.classList.add('paused');
					}
				});
			}

			lightbox.on("uiRegister", () => {
				// Prev arrow button
				lightbox.pswp.ui.registerElement({
					name: "custom-arrow-prev",
					ariaLabel: "Previous slide",
					order: 2,
					isButton: true,
					className: "gallery-prev-control",
					html: `<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 12 27" width="12" height="27"><path d="M.331 13.28 11.527 26.26c0-.453.008-.85-.006-1.247-.003-.076-.08-.157-.138-.223q-1.96-2.272-3.923-4.542l-3.458-4.01-2.54-2.948q.4-.457.798-.906L5.182 9.1 9.38 4.366q1.021-1.15 2.034-2.31a.5.5 0 0 0 .109-.288c.013-.347.005-.696.005-1.11z" fill="#392422" stroke="#392422" stroke-width=".5"/></svg>`,
					onClick: 'prev',
					appendTo: 'root',
				});

				// Next arrow button
				lightbox.pswp.ui.registerElement({
					name: "custom-arrow-next",
					ariaLabel: "Next slide",
					order: 3,
					isButton: true,
					className: "gallery-next-control",
					html: `<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 12 27" width="12" height="27"><path d="M11.45 13.28.254 26.26c0-.453-.007-.85.007-1.247.002-.076.08-.157.137-.223q1.962-2.272 3.923-4.542 1.73-2.003 3.459-4.01l2.539-2.948c-.268-.305-.531-.606-.797-.906Q8.06 10.741 6.599 9.1L2.4 4.366a324 324 0 0 1-2.034-2.31.5.5 0 0 1-.109-.288C.244 1.421.252 1.072.252.658z" fill="#392422" stroke="#392422" stroke-width=".5"/></svg>`,
					onClick: 'next',
		    		appendTo: 'root',
				});

				lightbox.pswp.ui.registerElement({
					name: 'custom-caption',
					order: 9,
					isButton: false,
					appendTo: 'root',
					html: '',
					onInit: (el, pswp) => {
						lightbox.pswp.on('change', () => {
							const currSlideElement = lightbox.pswp.currSlide.data.element;
							let captionHTML = '';
							if (currSlideElement) {
								const hiddenCaption = currSlideElement.querySelector('.hidden-caption-content');
								if (hiddenCaption) {
									// get caption from element with class hidden-caption-content
									captionHTML = hiddenCaption.innerHTML;
								}
							}
							el.innerHTML = captionHTML || '';
						});
					}
				});
			});

			lightbox.init();
		});
	});
}

document.addEventListener("DOMContentLoaded", initCarouselLightbox);
